export const create = {
  createSuccessfully: '言語作成は完了しました。',
}
